/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

export type BystanderTreatmentDataTreatmentPersonEnum =
  (typeof BystanderTreatmentDataTreatmentPersonEnum)[keyof typeof BystanderTreatmentDataTreatmentPersonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BystanderTreatmentDataTreatmentPersonEnum = {
  FAMILY_RELATIVE: 'FAMILY_RELATIVE',
  ACQUAINTANCE_COLLEAGUE: 'ACQUAINTANCE_COLLEAGUE',
  PARAMEDIC: 'PARAMEDIC',
  FIREFIGHTER: 'FIREFIGHTER',
  DOCTOR: 'DOCTOR',
  PUBLIC_HEALTH_NURSE: 'PUBLIC_HEALTH_NURSE',
  MIDWIFE: 'MIDWIFE',
  NURSE: 'NURSE',
  POLICE_OFFICER: 'POLICE_OFFICER',
  HELPER: 'HELPER',
  TEACHER: 'TEACHER',
  PASSERBY: 'PASSERBY',
  RELATED_PERSON: 'RELATED_PERSON',
  FIRE_BRIGADE_MEMBER: 'FIRE_BRIGADE_MEMBER',
  OTHER: 'OTHER',
} as const;
